// 工数見積り関連の共通ユーティリティ

export interface EstimationRowItem {
  selected?: boolean;
  [key: string]: string | boolean | number | undefined;
}

export interface UsecaseTableLike {
  headers?: string[];
  rows?: (string[] | EstimationRowItem)[];
}

export interface EstimationDocumentLikeContent {
  usecase_table?: UsecaseTableLike;
  [key: string]: unknown;
}

/**
 * ドキュメントの usecase_table から合計工数を算出する
 * 対象列は日本語ヘッダの「開発コスト」を想定
 * 非数値や空は 0 として扱う
 */
export function calculateTotalWorkloadsFromUsecaseTable(
  content: EstimationDocumentLikeContent,
): number {
  const table = content?.usecase_table;
  if (!table || !Array.isArray(table.headers) || !Array.isArray(table.rows)) return 0;

  const costHeaderIndex = table.headers.indexOf("開発コスト");
  if (costHeaderIndex === -1) return 0;

  let total = 0;
  for (const row of table.rows) {
    if (Array.isArray(row)) {
      const raw = row[costHeaderIndex];
      const value = typeof raw === "string" ? raw.trim() : String(raw ?? "").trim();
      const num = parseFloat(value || "0");
      if (Number.isFinite(num)) total += num;
    } else if (row && typeof row === "object") {
      const raw = row["開発コスト"];
      const value = typeof raw === "string" ? raw.trim() : String(raw ?? "").trim();
      const num = parseFloat(value || "0");
      if (row.selected === false) continue;
      if (Number.isFinite(num)) total += num;
    }
  }

  return total;
}
